import * as React from "react"
import { cn } from "@/lib/utils"

const CustomSwitch = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => (
  <label
    className={cn(
      "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200",
      checked ? "bg-blue-600" : "bg-gray-600",
      disabled && "cursor-not-allowed opacity-50",
      className
    )}
    {...props}
  >
    <input
      ref={ref}
      type="checkbox"
      checked={!!checked}
      disabled={disabled}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      className="sr-only"
    />
    <span
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg transition-transform duration-200",
        checked ? "translate-x-[22px]" : "translate-x-[2px]"
      )}
    />
  </label>
))
CustomSwitch.displayName = "CustomSwitch"

export { CustomSwitch }
